import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select-v2'
import { getProfileData, getSortDirection, getSortColumn, getProductTypeOption, getMgtStyleOption, getSelectedProductTypeOption, getSelectedMgtStyleOption, getSelectedTier1CatOption, getSelectedTier2CatOption, getSelectedTier3CatOption, getSelectedLeverageOption, getSelectedCountryExpOption, getSelectedProductRegionOption, getSelectedUseOfIncomeOption, getSelectedEsgOption, getSelectedInceptionOption, getSelectedAumOption, getSelectedYieldOption, getSelectedMstarOption, getSelectedVolumeOption, getSelectedExpenseOption, getTier1CatOption, getTier2CatOption, getTier3CatOption, getLeverageOption, getCountryExpOption, getProductRegionOption, getUseOfIncomeOption, getEsgOption, getInceptionOption, getAumOption, getMstarOption, getYieldOption, getExpenseOption, getVolumeOption } from '../../../reducers/data'
import { setSort, setProductType, setMgtStyle, setTier1Cat, setTier2Cat, setTier3Cat, setCountryExp, setProductRegion, clearFilters, setLeveraged, setUseOfIncome, setEsg, setInception, setAum, setYield, setMstar, setExpense, setVolume } from '../../../actions/data'
import './Filters.css'
import i18n from '../../../i18n'

const customStyles = {
  control: base => ({
    ...base,
    borderRadius: 0,
    background: 'white'
  }),
  option: (provided, state) => ({
    ...provided,
    color: '#5b6770',
    fontSize: 14,
    borderRadius: 0,
    ':active': {
      backgroundColor: state.isSelected ? 'white' : '#05A9B1',
      color: state.isSelected ? '#5b6770' : 'white'
    },
    ':hover': {
      backgroundColor: state.isSelected ? 'white' : '#05A9B1',
      color: state.isSelected ? '#5b6770' : 'white'
    }
  }),
  menu: base => ({
    ...base,
    borderRadius: 0
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = 'opacity 100ms'
    const color = state.isSelected ? '#5b6770' : '#5b6770'
    return { ...provided, opacity, transition, color }
  },
  multiValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 0.75
    const fontSize = '14px'
    return { ...provided, opacity, fontSize }
  },
  dropdownIndicator: base => ({
    ...base,
    color: '#05A9B1'
  })
}

class Filters extends Component {
  render() {
    const { data, productTypeOption, mgtStyleOption, useOfIncomeOption, tier1CatOption, tier2CatOption, tier3CatOption, leverageOption, countryExpOption, productRegionOption, esgOption, inceptionOption, aumOption, yieldOption, expenseOption, volumeOption, selectedProductTypeOption, selectedMgtStyleOption, selectedUseOfIncomeOption, selectedTier1CatOption, selectedTier2CatOption, selectedTier3CatOption, selectedLeverageOption, selectedCountryExpOption, selectedProductRegionOption, selectedEsgOption, selectedInceptionOption, selectedYieldOption, selectedMstarOption, selectedAumOption, selectedExpenseOption, selectedVolumeOption, setProductType, setMgtStyle, setTier1Cat, setTier2Cat, setTier3Cat, setLeveraged, setCountryExp, setProductRegion, setUseOfIncome, setEsg, setAum, setYield, setExpense, setVolume, setInception } = this.props

    function arrayToFormOptions(values) {
      return values.map(item => ({ value: item, label: item }))
    }

    function valueToFormValue(value) {
      if (value && value.length > 0) {
        return value.map(item => ({ value: item, label: item }))
      } else {
        return null
      }
    }

    function arrayToFormCustomOptions(values, type) {
      if (type === 'expense') {
        console.log('expense values', values)
      } else return values.map(item => ({ value: item, label: item }))
    }

    if (data) {
      return (
        <div className='fund'>
          <div className='fund-btn-toolbar' role='toolbar' aria-label='Toolbar with button groups'>
            <div className='row'>
              {this.props.isEU === false && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select
                    placeholder={i18n.t('AllManagementStyles')}
                    styles={customStyles}
                    isMulti
                    onChange={setMgtStyle}
                    options={arrayToFormOptions(mgtStyleOption)}
                    value={valueToFormValue(selectedMgtStyleOption)}
                    // closeMenuOnSelect={false}
                  />
                </div>
              )}
              <div className='col-sm-3 fund-btn-group'>
                <Select placeholder={i18n.t('AllAssetClasses')} styles={customStyles} isMulti onChange={setTier1Cat} options={arrayToFormOptions(tier1CatOption)} value={valueToFormValue(selectedTier1CatOption)} closeMenuOnSelect={false} />
              </div>
              <div className='col-sm-3 fund-btn-group'>
                <Select placeholder={i18n.t('AllSubAssetClasses')} styles={customStyles} isMulti onChange={setTier2Cat} options={arrayToFormOptions(tier2CatOption)} value={valueToFormValue(selectedTier2CatOption)} closeMenuOnSelect={false} />
              </div>
              {this.props.isEU && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select placeholder={i18n.t('IndustrySubGroups')} styles={customStyles} isMulti onChange={setTier3Cat} options={arrayToFormOptions(tier3CatOption)} value={valueToFormValue(selectedTier3CatOption)} closeMenuOnSelect={false} />
                </div>
              )}
              {this.props.isEU === false && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select placeholder={i18n.t('AllCountries')} styles={customStyles} isMulti onChange={setCountryExp} options={arrayToFormOptions(countryExpOption)} value={valueToFormValue(selectedCountryExpOption)} closeMenuOnSelect={false} />
                </div>
              )}
              {this.props.isEU && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select placeholder={i18n.t('AllRegions')} styles={customStyles} isMulti onChange={setProductRegion} options={arrayToFormOptions(productRegionOption)} value={valueToFormValue(selectedProductRegionOption)} closeMenuOnSelect={false} />
                </div>
              )}
            </div>

            <div className='row'>
              {this.props.isEU === false && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select placeholder={i18n.t('aumplaceholder')} styles={customStyles} isMulti={false} onChange={setAum} options={arrayToFormCustomOptions(aumOption, 'aum')} />
                </div>
              )}
              {this.props.isEU === false && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select
                    placeholder={i18n.t('inceptionplaceholder')}
                    styles={customStyles}
                    isMulti={false}
                    onChange={setInception}
                    options={arrayToFormOptions(inceptionOption)}
                    //value={valueToFormValue(selectedInceptionOption)}
                    //closeMenuOnSelect={false}
                  />
                </div>
              )}

              {this.props.isEU === false && this.props.division === '1' && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select
                    placeholder={i18n.t('volumeplaceholder')}
                    styles={customStyles}
                    isMulti={false}
                    onChange={setVolume}
                    options={arrayToFormOptions(volumeOption)}
                    // value={valueToFormValue(selectedInceptionOption)}
                    //closeMenuOnSelect={false}
                  />
                </div>
              )}

              {this.props.isEU === false && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select
                    placeholder={i18n.t('ttmyieldplaceholder')}
                    styles={customStyles}
                    isMulti={false}
                    onChange={setYield}
                    options={arrayToFormOptions(yieldOption)}
                    // value={valueToFormValue(selectedInceptionOption)}
                    //closeMenuOnSelect={false}
                  />
                </div>
              )}
              {this.props.isEU === false && this.props.division === '3' && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select placeholder={i18n.t('expenseplaceholder')} styles={customStyles} isMulti={false} onChange={setExpense} options={arrayToFormOptions(expenseOption)} />
                </div>
              )}
            </div>

            <div className='row'>
              {this.props.isEU === false && this.props.division === '1' && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select placeholder={i18n.t('expenseplaceholder')} styles={customStyles} isMulti={false} onChange={setExpense} options={arrayToFormOptions(expenseOption)} />
                </div>
              )}
            </div>

            <div className='row'>
              {this.props.isEU && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select
                    placeholder={i18n.t('AllProductTypes')}
                    styles={customStyles}
                    isMulti
                    onChange={setProductType}
                    options={arrayToFormOptions(productTypeOption)}
                    value={valueToFormValue(selectedProductTypeOption)}
                    //closeMenuOnSelect={false}
                  />
                </div>
              )}
              {this.props.isEU && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select placeholder={i18n.t('LeverageFactor')} styles={customStyles} isMulti onChange={setLeveraged} options={arrayToFormOptions(leverageOption)} value={valueToFormValue(selectedLeverageOption)} closeMenuOnSelect={false} />
                </div>
              )}
              {this.props.isEU && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select
                    placeholder={i18n.t('AllStructure')}
                    styles={customStyles}
                    isMulti
                    onChange={setMgtStyle}
                    options={arrayToFormOptions(mgtStyleOption)}
                    value={valueToFormValue(selectedMgtStyleOption)}
                    // closeMenuOnSelect={false}
                  />
                </div>
              )}
              {this.props.isEU && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select
                    placeholder={i18n.t('UseOfIncome')}
                    styles={customStyles}
                    isMulti
                    onChange={setUseOfIncome}
                    options={arrayToFormOptions(useOfIncomeOption)}
                    value={valueToFormValue(selectedUseOfIncomeOption)}
                    // closeMenuOnSelect={false}
                  />
                </div>
              )}
            </div>

            <div className='row'>
              {this.props.isEU && (
                <div className='col-sm-3 fund-btn-group'>
                  <Select
                    placeholder={i18n.t('responsibleInvesting')}
                    styles={customStyles}
                    isMulti
                    onChange={setEsg}
                    options={arrayToFormOptions(esgOption)}
                    value={valueToFormValue(selectedEsgOption)}
                    //closeMenuOnSelect={false}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}

function mapStateToProps(state) {
  return {
    data: getProfileData(state),
    productTypeOption: getProductTypeOption(state),
    mgtStyleOption: getMgtStyleOption(state),
    tier1CatOption: getTier1CatOption(state),
    tier2CatOption: getTier2CatOption(state),
    tier3CatOption: getTier3CatOption(state),
    leverageOption: getLeverageOption(state),
    countryExpOption: getCountryExpOption(state),
    inceptionOption: getInceptionOption(state),
    aumOption: getAumOption(state),
    yieldOption: getYieldOption(state),
    mstarOption: getMstarOption(state),
    volumeOption: getVolumeOption(state),
    expenseOption: getExpenseOption(state),
    productRegionOption: getProductRegionOption(state),
    useOfIncomeOption: getUseOfIncomeOption(state),
    esgOption: getEsgOption(state),
    selectedProductTypeOption: getSelectedProductTypeOption(state),
    selectedMgtStyleOption: getSelectedMgtStyleOption(state),
    selectedTier1CatOption: getSelectedTier1CatOption(state),
    selectedTier2CatOption: getSelectedTier2CatOption(state),
    selectedTier3CatOption: getSelectedTier3CatOption(state),
    selectedLeverageOption: getSelectedLeverageOption(state),
    selectedCountryExpOption: getSelectedCountryExpOption(state),
    selectedInceptionOption: getSelectedInceptionOption(state),
    selectedAumOption: getSelectedAumOption(state),
    selectedYieldOption: getSelectedYieldOption(state),
    selectedMstarOption: getSelectedMstarOption(state),
    selectedVolumeOption: getSelectedVolumeOption(state),
    selectedExpenseOption: getSelectedExpenseOption(state),
    selectedProductRegionOption: getSelectedProductRegionOption(state),
    selectedUseOfIncomeOption: getSelectedUseOfIncomeOption(state),
    selectedEsgOption: getSelectedEsgOption(state),
    sortDirection: getSortDirection(state),
    sortColumn: getSortColumn(state)
  }
}

export default connect(mapStateToProps, {
  setSort,
  setProductType,
  setLeveraged,
  setMgtStyle,
  setTier1Cat,
  setTier2Cat,
  setTier3Cat,
  setCountryExp,
  setInception,
  setAum,
  setMstar,
  setProductRegion,
  clearFilters,
  setUseOfIncome,
  setEsg,
  setYield,
  setExpense,
  setVolume
})(Filters)



// WEBPACK FOOTER //
// ./src/components/App/Filters/Filters.js